import httpRequest from "@/auth/http-client";
import { buildPaginationQuery, sanitizeFilters } from "@/helpers/request-helpers";
import {
  IServiceInterfaceLog,
  IServiceInterfaceLogType,
} from "@/interfaces/service-interface.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class ServiceInterfaceLogService {
  private baseUrl = "api/v1.0/serviceinterfacelog";

  async getLogTypes(): Promise<IServiceInterfaceLogType[]> {
    return httpRequest.get(`${this.baseUrl}/logtypes`);
  }

  async filter(
    serviceInterfaceId: number,
    filters: IFilter<IServiceInterfaceLog>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IServiceInterfaceLog>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const filter = sanitizeFilters(filters);

    return httpRequest.post(
      `${this.baseUrl}/filter?serviceInterfaceId=${serviceInterfaceId}&${paginationQuery}`,
      { filter }
    );
  }
}

const serviceInterfaceLogService = new ServiceInterfaceLogService();
export default serviceInterfaceLogService;
